import {useAppDispatch, useAppSelector} from "@/lib/store.ts";
import {initSignupFromInvite, signupUser} from "@/app/auth/signup/signup.slice.ts";
import {SignupPayload} from "@/app/auth/signup/signup.entity.ts";
import {useEffect} from "react";

export function useSignup(path: "plain" | "orgInvite", token?: string) {
    const dispatch = useAppDispatch();
    const state = useAppSelector(s => s.signup);

    const submit = async (payload: SignupPayload) => await dispatch(signupUser({path, payload, token})).unwrap();

    return {...state, submit};
}

export function useSignupInviteInit(token: string | null) {
    const dispatch = useAppDispatch();
    const { inviteInitLoading, inviteInitError } = useAppSelector(
        (s) => s.signup,
    );

    useEffect(() => {
        if (token) dispatch(initSignupFromInvite(token));
    }, [token, dispatch]);

    return { inviteInitLoading, inviteInitError };
}